import { render, staticRenderFns } from "./nequi.vue?vue&type=template&id=f3027948&scoped=true&"
import script from "./nequi.vue?vue&type=script&lang=js&"
export * from "./nequi.vue?vue&type=script&lang=js&"
import style0 from "./nequi.vue?vue&type=style&index=0&id=f3027948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3027948",
  null
  
)

export default component.exports